import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-todays-offer',
  templateUrl: './todays-offer.component.html',
  styleUrls: ['./todays-offer.component.scss']
})
export class TodaysOfferComponent {
  dOfferSlider: OwlOptions = {
    loop: false,
    margin: 10,
    autoplay: false,
    dots: false,
    autoplayTimeout: 3000,
    smartSpeed: 2500,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      380: {
        items: 2,
      },
      576: {
        items: 3,
      },
      768: {
        items: 4,
        margin: 10
      },
      992: {
        items: 4,
        margin: 20
      },
      1200: {
        items: 4,
        margin: 20
      },
      1500: {
        items: 5,
        margin: 30
      }
    }
  }

  saleSlider: OwlOptions = {
    loop: true,
    margin: 10,
    autoplay: false,
    nav: false,
    dots: false,
    autoplayTimeout: 3000,
    smartSpeed: 2500,
    responsive: {
      0: {
        items: 1,
      },
      380: {
        items: 2,
      },
      576: {
        items: 3,
      },
      768: {
        items: 4,
        margin: 10
      },
      992: {
        items: 4,
        margin: 20
      },
      1200: {
        items: 5,
        margin: 20
      },
      1500: {
        items: 6,
        margin: 30
      }
    }
  }
}
